import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import '@hobs/polyfill/closest';
import '@hobs/polyfill/remove';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import store, { history } from './store';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';
import '@progress/kendo-theme-default/dist/all.css';
import '@hobs/styles/grid.scss';
import '@hobs/styles/global.scss';

i18n.use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: require('./translations/en.json')
      }
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
